import { Card, CardContent } from "@/components/ui/card";
import {
  CanAccess,
  EditBase,
  Form,
  useEditContext,
  type MutationMode,
} from "ra-core";
import { Navigate } from "react-router";

import type { Contact } from "../types";
import { ContactAside } from "./ContactAside";
import { ContactInputs } from "./ContactInputs";
import { FormToolbar } from "../layout/FormToolbar";
import {
  cleanupContactForEdit,
  defaultEmailJsonb,
  defaultPhoneJsonb,
} from "./contactModel";

export const ContactEdit = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => (
  <EditBase
    redirect="show"
    transform={cleanupContactForEdit}
    mutationMode={mutationMode}
  >
    <ContactEditContent />
  </EditBase>
);

const normalizeContactArrayFields = (record: Contact) => ({
  ...record,
  email_jsonb:
    record.email_jsonb && record.email_jsonb.length > 0
      ? record.email_jsonb
      : defaultEmailJsonb,
  phone_jsonb:
    record.phone_jsonb && record.phone_jsonb.length > 0
      ? record.phone_jsonb
      : defaultPhoneJsonb,
});

const ContactEditContent = () => {
  const { isPending, record } = useEditContext<Contact>();
  if (isPending || !record) return null;
  return (
    // Almikia Epic E3b (TASK-065): useEditController checks access before
    // the record is fetched, so a direct edit URL always passes a lider
    // through to a team member's edit form; the record only exists here,
    // once EditBase's RecordContext is populated, so the record-level guard
    // has to live here instead.
    <CanAccess
      resource="contacts"
      action="edit"
      accessDenied={<Navigate to={`/contacts/${record.id}/show`} replace />}
    >
      <div className="mt-2 flex gap-8">
        <Form
          className="flex flex-1 flex-col gap-4"
          record={normalizeContactArrayFields(record)}
        >
          <Card>
            <CardContent>
              <ContactInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>

        <ContactAside link="show" />
      </div>
    </CanAccess>
  );
};
